/**
 * 스트레스 레벨별 메시지 테이블
 */
export const TBL_HR_FEEDBACK = [
    {
        level: 0,
        range: "데이터 없음",
        info: "초기 상태",
        message1: "평온한 상태예요. 마음이 잘 안정되어 있습니다.",
        message2: "지금은 편안한 상태입니다. 좋은 컨디션이에요.",
        message3: "안정적인 상태로 보입니다. 이대로 유지해보세요.",
        message4: "균형 잡힌 상태입니다. 무리하지 않고 천천히 하루를 보내세요.",
        message5: "마음이 차분하고 안정된 상태예요."
    },
    {
        level: 1,
        range: "0~5",
        info: "안정 상태",
        message1: "지금 아주 편안한 상태예요. 이 기분을 유지해보세요.",
        message2: "마음이 안정되어 있어요. 좋은 컨디션입니다.",
        message3: "차분한 하루를 보내고 계시네요.",
        message4: "몸과 마음이 잘 균형을 이루고 있어요.",
        message5: "평온한 상태예요. 이대로 유지해보세요."
    },
    {
        level: 2,
        range: "6~9",
        info: "약간 긴장 상태",
        message1: "약간의 긴장감이 느껴져요. 가볍게 심호흡해보세요.",
        message2: "살짝 긴장된 상태예요. 천천히 호흡해보세요.",
        message3: "살짝 예민해진 순간이에요. 어깨를 한번 돌려볼까요?",
        message4: "집중도가 높아진 상태예요. 잠시 시선을 멀리 두세요.",
        message5: "잠깐의 여유를 가지면 곧 편안해질 거예요."
    },
    {
        level: 3,
        range: "10~14",
        info: "긴장 상태",
        message1: "긴장도가 조금 높아지고 있어요. 짧은 휴식이 좋습니다.",
        message2: "몸이 긴장되어 있어요. 짧은 휴식을 취해보세요.",
        message3: "잠시 긴장된 순간이에요. 자리에서 일어나 스트레칭을 해보세요.",
        message4: "휴식이 필요할 때입니다. 눈을 감고 잠시 쉬어보세요.",
        message5: "몸이 살짝 경직될 수 있어요. 부드럽게 이완해보세요."
    },
    {
        level: 4,
        range: "15~19",
        info: "높은 상태",
        message1: "긴장감이 높은 상태입니다. 짧게라도 쉬어보세요.",
        message2: "피로가 쌓이고 있는 신호예요. 몸을 조금 풀어주세요.",
        message3: "마음이 무거워질 때는 한두 번 깊게 호흡하는 게 좋아요.",
        message4: "짧은 휴식이 컨디션 회복에 도움이 됩니다.",
        message5: "의식적으로 호흡을 천천히 하면서 몸을 이완해보세요."
    },
    {
        level: 5,
        range: "20 이상",
        info: "매우 높은 상태",
        message1: "긴장이 많이 쌓였어요. 잠시 휴식을 권장합니다.",
        message2: "스트레스가 많이 쌓인 상태예요. 충분한 휴식을 권장합니다.",
        message3: "지금은 잠시 멈추고 몸과 마음을 쉬게 해주세요.",
        message4: "피로가 누적된 듯해요. 짧은 산책이 도움이 됩니다.",
        message5: "편안한 음악이나 조용한 공간에서 잠시 쉬면 도움이 됩니다."
    }
];

